import { NavigationPath } from '../dto/navigationDTO';

export const createNavigationPath = ( path: NavigationPath, ...params: string[] ) => path.replace( /(:[a-zA-Z]+)/g, () => params.shift()! );
